export interface CoopConsentFormValues {
  coopConsent: boolean;
}

export interface CoopSelectMembershipFormValues {
  coopSelectedMembership: string;
}

export enum HuseierneMembershipStatus {
  HAS_HUSEIERNE_MEMBERSHIP = "HAS_HUSEIERNE_MEMBERSHIP",
  WANTS_HUSEIERNE_MEMBERSHIP = "WANTS_HUSEIERNE_MEMBERSHIP",
}

export interface HuseierneMembershipStatusFormValues {
  huseierneMembershipStatus: HuseierneMembershipStatus;
}

export interface IsHuseierneMembershipConfirmationFormValues {
  wantsHuseierneMembershipConfirmation?: boolean;
  isHuseierneMembershipConfirmation: boolean;
}

export interface HasAkaUnionAffiliationConsentFormValues {
  hasAkaUnionAffiliationConsent: boolean;
}
